module.exports = __webpack_public_path__ + "img/leighton_b3.f4f01ec8.jpg";